import { useTranslation } from "react-i18next";
import { useRemoveCompareItemMutation } from "../api/compareApi";
import { useMutationWithFeedback } from "../../../../common/hooks/useMutationWithFeedback";

/**
 * A custom hook to encapsulate the logic for removing an item from the 'Compare' list.
 */
export const useRemoveFromCompare = () => {
  const { t } = useTranslation();
  const [removeCompareItem, result] = useRemoveCompareItemMutation();

  const { trigger: handleRemoveFromCompare, isLoading: isRemoving } =
    useMutationWithFeedback<number[], number>({
      mutation: [removeCompareItem, result],
      loadingMessage: t("feedback.compare.loading", "Updating compare list..."),
      successMessage: t(
        "feedback.compare.removedSuccess",
        "Removed from compare list"
      ),
      errorMessages: {
        default: t("feedback.compare.error", "Could not update compare list."),
      },
      successToastType: "info",
    });

  return {
    handleRemoveFromCompare,
    isRemoving,
  };
};
